module.exports = __webpack_public_path__ + "img/614.564af492.jpg";